import {Routes} from '@angular/router';

import {AuthGuard} from './app.guards';
import {appReadyGuard} from './core/guards/app-ready.guard';
import {InternalRoutes} from './core/models/internal-routes';
import {ErrorComponent} from './core/ui/error/error.component';
import {AuthCallbackComponent} from './entry-routes/authentication/auth-callback/auth-callback.component';

export const appRoutes: Routes = [
  {
    path: InternalRoutes.ERROR,
    component: ErrorComponent,
    // canActivate: [appReadyGuard]
  },
  {
    path: InternalRoutes.LOGIN,
    component: AuthCallbackComponent,
    //canActivate: [appReadyGuard]
  },
  // routes with authentication
  {
    path: '',
    canActivateChild: [AuthGuard, appReadyGuard],
    children: [
      {
        path: InternalRoutes.SEARCH,
        //canActivateChild: [AuthGuard],
        loadChildren: () => import('./entry-routes/search/search-routes').then( m => m.searchRoutes)
      },
      {
        path: InternalRoutes.ENTITIES,
        children: [
          {
            path: '', redirectTo: '/' + InternalRoutes.SEARCH, pathMatch: 'full' // no entity type -> home page
          },
          {
            path: ':entityType', redirectTo: ':entityType/' + InternalRoutes.SEARCH, pathMatch: 'full' // default page for an entity type -> search page
          },
          {
            path: ':entityType/' + InternalRoutes.SEARCH,
            loadChildren: () => import('./entry-routes/entity-search/entity-search-routes').then( m => m.entitySearchRoutes)
          },
          {
            path: ':entityType',
            loadChildren: () => import('./entry-routes/entity/entity-details/entity-details-routes').then( m => m.entityDetalisRoutes)
          }
        ]
      },
      {
        path: InternalRoutes.WORKFLOW,
        loadChildren: () => import('./entry-routes/workflow/workflow-routes').then( m => m.workflowRoutes)
      },
      {
        path: InternalRoutes.INDEXATION,
        loadChildren: () => import('./entry-routes/indexation/indexation-routes').then( m => m.indexationRoutes)
      },
      {
        path: InternalRoutes.DOMAIN,
        loadChildren: () => import('./entry-routes/domain/domain-routes').then( m => m.domainRoutes)
      },
      {
        path: InternalRoutes.DOCUMENTS + '/:id',
        loadChildren: () => import('./entry-routes/document/document-details/document-details-routes').then( m => m.documentDetailsRoutes)
      },
      {
        path: InternalRoutes.SUPPORT,
        loadChildren: () => import('./entry-routes/support/support-routes').then( m => m.supportRoutes)
      },
      {
        path: InternalRoutes.BASKET,
        children: [
          {
            path: InternalRoutes.DOCUMENTS,
            loadChildren: () => import('./entry-routes/basket/basket-routes').then( m => m.basketRoutes)
          },
          {
            path: InternalRoutes.ENTITIES,
            loadChildren: () => import('./entry-routes/basket/basket-routes').then( m => m.basketRoutes)
          }
        ]
      },
      {
        path: InternalRoutes.TECHBI,
        loadChildren: () => import('./entry-routes/techbi/techbi-routes').then( m => m.techbiRoutes)
      },
      {
         path: InternalRoutes.DELEGATIONS_MANAGEMENT,
         loadChildren: () => import('./entry-routes/delegations-managment/delegations-management-routes').then( m => m.delegationsManagementRoutes)
      },
      {
        path: '**', redirectTo: InternalRoutes.SEARCH
      }
    ]
  }
];
